import {MANAGER_STATUS, USER_ROLE} from '../../../../_gori/constants'
import {TIER_CODE_ENTERPRISE} from '../../common/core/_const'
import {UserModel} from './_models'

export const isEnterprise = (user?: UserModel | null) => user?.plan === TIER_CODE_ENTERPRISE

export const isOwner = (user?: UserModel | null) => user?.role === USER_ROLE.OWNER

export const isManager = (user?: UserModel | null) => user?.role === USER_ROLE.MANAGER

export const isEnterpriseManager = (user?: UserModel | null) =>
  isEnterprise(user) && isManager(user)

export const isActiveEnterpriseManager = (user?: UserModel | null) =>
  isEnterpriseManager(user) && user?.manager_status === MANAGER_STATUS.ACTIVE

export const isEnterpriseOwner = (user?: UserModel | null) => isEnterprise(user) && isOwner(user)
